export const errorHandler = (error = {}) => {
  let errors = {};

  if (error && error.response && error.response.data) {
    if (
      error.response.data.errors &&
      Object.keys(error.response.data.errors).length
    ) {
      // multiple errors
      errors = error.response.data.errors;
    } else {
      errors.global = error.response.data.message;
    }
  } else if (error && error.errors && Object.keys(error.errors).length) {
    errors = error.errors;
  } else if (error && error.message) {
    errors.global = error.message;
  }

  return errors;
};
